const IDS = {
    MODEL: 'mb',
    COBRANDED: 'wp',
  },
  HOSTS = {
    MODEL: 'openbank.de',
    COBRANDED: 'kunden.openbankpay.com',
  },
  REGEX_ENVS = 'DEV|STG|QA|DEMO',
  REGEX_IGNORE_FLAGS = 'i',
  CDN_ASSETS_HOST = 'https://assets.openbank.de';

export { CDN_ASSETS_HOST, IDS, HOSTS, REGEX_ENVS, REGEX_IGNORE_FLAGS };
